export default __webpack_public_path__ + "static/char-05-4de91aa83a63fd508c574c2d6b043616.gif";